export default "__VITE_ASSET__BdaMHIDZ__"